<template>
  <div class="props-group">
    <el-form-item label="高度自适应">
      <el-checkbox v-model="component.properties.heightAdaptation"></el-checkbox>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'height-adaptation',
  props: ['component']
}
</script>



// WEBPACK FOOTER //
// src/components/form/componentAttr/height-adaptation.vue